import * as z from 'zod';

import type { CoworkerPreferences } from '@repo/utils';

export interface CoworkerPreferencesDetails extends CoworkerPreferences {
    buCode: string;
    coworkerMeetingPoint?: string;
    coworkerWorkArea?: string;
    language?: string;
    storeName?: string;
}

const coworkerPreferencesSchema = z.object({
    buCode: z.string().min(1),
    coworkerMeetingPoint: z.optional(z.string()),
    coworkerWorkArea: z.optional(z.string()),
    language: z.optional(z.string()),
    storeName: z.optional(z.string()),
});

export const isCoworkerPreferences = (value: unknown): value is CoworkerPreferencesDetails => {
    return coworkerPreferencesSchema.safeParse(value).success;
};
